export const DRAWER_ANCHOR = {
  BOOTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
};



// WEBPACK FOOTER //
// ./src/views/components/Common/DrawerPanel/Constants.js